/**
 * Action creators for the Document Artifact system.
 *
 * All actions are keyed by `artifactId` so multiple artifacts can coexist.
 */

import {
  ARTIFACT_LOAD,
  ARTIFACT_COMMIT,
  ARTIFACT_UNDO,
  ARTIFACT_REDO,
  ARTIFACT_SET_DIRTY,
  ARTIFACT_RESET,
} from '../constants/artifact';

/**
 * Load content into an artifact without creating an undo entry.
 * Use for initial fetch, external sync, or resetting to a known state.
 */
export const loadArtifact = (artifactId, content) => ({
  type: ARTIFACT_LOAD,
  artifactId,
  content,
});

/**
 * Commit new content to an artifact with undo history.
 * Pushes current content to undo stack, clears redo stack, sets new content.
 * Use for user edits, programmatic edits, or any intentional content change.
 */
export const commitArtifact = (artifactId, content, label = '') => ({
  type: ARTIFACT_COMMIT,
  artifactId,
  content,
  label,
});

/**
 * Navigate to previous artifact state.
 */
export const undoArtifact = (artifactId) => ({
  type: ARTIFACT_UNDO,
  artifactId,
});

/**
 * Navigate to next artifact state (after an undo).
 */
export const redoArtifact = (artifactId) => ({
  type: ARTIFACT_REDO,
  artifactId,
});

/**
 * Manually set the dirty flag (e.g., clear it after a successful save).
 */
export const setArtifactDirty = (artifactId, dirty) => ({
  type: ARTIFACT_SET_DIRTY,
  artifactId,
  dirty,
});

/**
 * Clear all state for an artifact (removes it from the store).
 */
export const resetArtifact = (artifactId) => ({
  type: ARTIFACT_RESET,
  artifactId,
});
